import { render, staticRenderFns } from "./Horses.vue?vue&type=template&id=2d14bb8d"
import script from "./Horses.vue?vue&type=script&lang=js"
export * from "./Horses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports